// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"aabd98cf","248":"b0b75680"}[chunkId] + ".chunk.css";
};